/**
 * Replaces placeholders in a text with values from an object.
 * Placeholders are enclosed in double curly braces and can have optional whitespace around the key.
 * If the key is not found in the object, the placeholder is left unchanged.
 * @param {string} text - The text to process.
 * @param {Record<string, string>} placeholders - The object that maps keys to values.
 * @returns {string} The text with the placeholders replaced.
 * @example
 * replacePlaceholders("Hello {{ name }}!", {name: "Alice"}); // returns "Hello Alice!"
 * replacePlaceholders("The weather is {{ adjective }} today.", {adjective: "sunny"}); // returns "The weather is sunny today."
 * replacePlaceholders("I like {{ fruit }} and {{ vegetable }}.", {fruit: "apples"}); // returns "I like apples and {{ vegetable }}."
 */
export const replacePlaceholders = (text: string, placeholders: Record<string, string | number>) =>
  text?.replace(/{{(.*?)}}/g, (match, key) => String(placeholders[key.trim()] || match));
